import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./iconInteractive.html";
import { Size, Theme, TransparentBackground } from '@oneappexchange/appx-design-system/modules/ax/iconInteractive/iconInteractive.constants';
export const BUTTON = 'button';
export const LINK = 'link';
class IconInteractive extends LightningElement {
  constructor(...args) {
    super(...args);
    this.theme = Theme.Default;
    this.size = Size.Default;
    this.ariaLabel = null;
    this.ariaLive = null;
    this.type = null;
    this.form = null;
    this.disabled = false;
    this.href = null;
    this.name = null;
    this.icon = void 0;
    this.iconDescription = void 0;
    this.spriteUrl = void 0;
    this.transparentBackground = TransparentBackground.Default;
  }
  get analyticsSourceProps() {
    return {
      disabled: this.disabled,
      size: this.size,
      theme: this.theme,
      icon: this.icon,
      iconDescription: this.iconDescription,
      callToAction: {
        label: this.name,
        name: this.name,
        url: this.href
      }
    };
  }
  get elementType() {
    return this.href ? LINK : BUTTON;
  }
  get accessibleLabel() {
    return this.ariaLabel || this.iconDescription;
  }
  handleAnalytics(event) {
    event.detail[this.elementType] = this.analyticsSourceProps;
  }
  handleClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }

  /** Focuses the wrapped design-system control without exposing its shadow-DOM structure. */
  focusButton() {
    const template = this.template;
    if (!template) {
      return;
    }
    const control = template.querySelector('ax-icon-interactive');
    const button = control?.shadowRoot?.querySelector('ax-button');
    (button ?? control ?? template.host).focus();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(IconInteractive, {
  publicProps: {
    theme: {
      config: 0
    },
    size: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    type: {
      config: 0
    },
    form: {
      config: 0
    },
    disabled: {
      config: 0
    },
    href: {
      config: 0
    },
    name: {
      config: 0
    },
    icon: {
      config: 0
    },
    iconDescription: {
      config: 0
    },
    spriteUrl: {
      config: 0
    },
    transparentBackground: {
      config: 0
    }
  },
  publicMethods: ["focusButton"]
});
const __lwc_component_class_internal = _registerComponent(IconInteractive, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;